import { createBrowserWebview, NativeClient } from "@realestate.com.au/webview";

export const getNativeClient = (): NativeClient | undefined => {
  const webview = createBrowserWebview();
  return webview.client;
};
